import { useContext, useEffect, useState, useCallback } from "react"
import Aside from "../../../components/Aside"
import Footer from "../../../components/Footer"
import Header from "../../../components/Header"
import { useCurrentAccount } from "../../../hooks/useCurrentAccount"
import { DateUtil } from "../../../utils/date"
import { ReportService } from "../../../services/ReportsService"
import CustomDataTable from "../../../components/CustomDataTable"
import { AppContext } from "../../../context/AppContext"
import { useTranslation } from "react-i18next"
import * as XLSX from 'xlsx';
import { ChannelUtil } from "../../../utils/channel"
import useTokenApi from "../../../hooks/useTokenApi"
import FullPieChart from "../../../components/FullPieChart"
import useRequest from "../../../hooks/useRequest"
import usePermission from "../../../hooks/usePermission"

function LicensesPage() {

    const { t }= useTranslation();
    const {call, isRequesting} = useRequest();
    const { account } = useCurrentAccount();
    const { tokenApi } = useTokenApi();
    const hasDownloadAccess = usePermission('reports.download');
    const [rows, setRows] = useState([])
    const [filteredRows, setFilteredRows] = useState<any[]>([]);
    

    const [filterRangeDates, setFilterRangeDates] = useState({ start: null, end: null })

    const [fullPieChartData, setFullPieChartData] = useState({show: false, data: [], title: ''})

    const columns = [
        {
            name: "ID Cuenta",
            sortable: true,
            cell: row => row.id_cuenta
        },
        {
            name: "Cuenta",
            sortable: true,
            cell: row => row.nombre
        },
        {
            name: "Mes",
            sortable: true,
            cell: row => row.mes
        },
        {
            name: "Agente",
            sortable: true,
            cell: row => row.username
        },
        
    ];


    const formatCategory = (category?: string) => {
        if (+account.account_id === 188 && category && category.toLowerCase() === 'convenio del bot') {
          return `99 ${category}`;
        }
    
    
        return category;
    }

    const handleRowsFiltered = useCallback((filteredRows: any) => {
        setFilteredRows(prevRows => {
            if (JSON.stringify(prevRows) !== JSON.stringify(filteredRows)) {
                return filteredRows;
            }
            return prevRows;
        });
    }, []);

    const downloadReport = (isCSV = false) => {

        const HEADER = [
          'ID CUENTA',
          'CUENTA',
          'MES',
          'AGENTE'
        ];
    
        
    
        const data = filteredRows.map(row => {

          const fields = {
            'ID CUENTA': row.id_cuenta,
            'CUENTA': row.nombre,
            'MES': row.mes,
            'AGENTE': row.username,
          };
    
          return fields;
        });
        const wb = XLSX.utils.book_new();
    
        const ws = XLSX.utils.json_to_sheet(data, {
          header: HEADER
        });
    
        if (isCSV) {
          const csv = XLSX.utils.sheet_to_csv(ws, {FS: '|'});
    
          const blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-18' });
          const link = document.createElement('a');
          if (link.download !== undefined) {
            const url = URL.createObjectURL(blob);
            link.setAttribute('href', url);
            link.setAttribute('download', 'reporte-licencias.csv');
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
    
        } else {
          XLSX.utils.book_append_sheet(wb, ws);
          return XLSX.writeFile(wb, 'reporte-licencias.xlsx');
        }
    }
    

    const getReport = async () => {

        if (filterRangeDates.start && filterRangeDates.end) {
            const start = filterRangeDates.start.format('YYYY-MM-DD')
            const end = filterRangeDates.end.format('YYYY-MM-DD')
            const { data } = await call(() => ReportService.getLicenses(start, end));          
            setRows(data)
        }
    }

    useEffect(() => {
        getReport()
    }, [filterRangeDates])

    return (
        <>
            <Header />
            <Aside />

            <main id="content" role="main" className="main">

                <div className="content container-fluid">

                    <div className="page-header">
                        <div className="row align-items-center">
                            <div className="col-sm mb-2 mb-sm-0">
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb breadcrumb-no-gutter">
                                        <li className="breadcrumb-item "><span className="breadcrumb-link" >{t("reports.operation-title")}</span></li>
                                        <li className="breadcrumb-item " aria-current="page">{t("reports.reports-title")}</li>
                                        <li className="breadcrumb-item active" aria-current="page">Licencias</li>
                                    </ol>
                                </nav>
                                <h1 className="page-header-title text-white-dark"><i className="bi-grid-1x2-fill nav-icon text-primary fw-bolder "></i> {t("reports.reports-title")} - Licencias</h1>
                            </div>
                        </div>
                    </div>


                    <CustomDataTable
                        columns={columns}
                        showDates
                        data={rows}
                        hideAccountsFilter
                        isLoading={isRequesting}
                        filterDay={0}
                        onRowsFiltered={handleRowsFiltered}
                        onExport={hasDownloadAccess ? (format) => downloadReport(format === 'csv') : null}
                        onDatesChange={(range) => setFilterRangeDates(range)}
                        filter={(row, term) => {
                            if (!term) return true;

                            return (
                                `${row.id_cuenta}`.match(new RegExp(`${term}`, 'i')) || 
                                `${row.nombre}`.match(new RegExp(`${term}`, 'i')) || 
                                `${row.mes}`.match(new RegExp(`${term}`, 'i')) || 
                                `${row.username}`.match(new RegExp(`${term}`, 'i'))
                            )
                        }}
                    />

                </div>
                <Footer />
            </main>

            <FullPieChart 
                show={fullPieChartData.show}
                data={fullPieChartData.data}
                title={fullPieChartData.title}
                onRequestClose={() => setFullPieChartData({ show: false, data: [], title: ''})}
            />
        </>
    )
}
export default LicensesPage